import { TextArea } from 'common/InputForm';
import useButtonLoader from 'common/UseButtonLoader';
import { CustomModal } from 'components/modals/ModalBox';
import React, { useState } from 'react'
import { addReportApi } from 'services/report';
import { toastMessage } from 'utils/toastMessage';

const Report = ({ reportDetails, close, listing = () => { } }) => {
    const [errors, setErrors] = useState({});
    const [buttonLoaders, setButtonLoaders] = useButtonLoader("submit");
    const [input, setInput] = useState({ responseMessage: "" })
    //----------validation-------------
    const validation = () => {
        let status = true
        let errorMessage = {}
        if (!input?.responseMessage) {
            errorMessage['responseMessage'] = 'please enter report'
            status = false
        }
        setErrors(errorMessage)
        return status
    }
    const handInput = (e) => {
        const { name, value } = e.target
        setInput({ ...input, [name]: value.replace(/^\s+/, "") })
    }
    //-----------modal-close-------------
    const modalClose = () => {
        close()
        setInput({ responseMessage: "" })
    }
    //------------add-report-----------------
    const addReport = async (e) => {
        e.preventDefault();
        if (validation()) {
            setButtonLoaders(true);
            try {
                const res = await addReportApi({ ...input, reportId: reportDetails?.id });
                if (res?.data?.status === 200) {
                    toastMessage(res?.data?.message, "success", "report");
                    setInput({});
                    modalClose()
                    listing()
                } else {
                    toastMessage(res?.data?.message, "error", "addFaq");
                }
            } catch (e) {
                console.log("Error:", e.message);
            } finally {
                setButtonLoaders(false);
            }
        }
    };
    return (
        <CustomModal
            className={"add_model"}
            show={reportDetails?.modal}
            handleClose={modalClose}
        >
            <h3>Report</h3>
            <div className="add_model">
                <div className="form_field">
                    <TextArea
                        label="Report"
                        type={"text"}
                        name={'responseMessage'}
                        value={input.responseMessage || ""}
                        maxLength='300'
                        onChange={handInput}
                        placeholder="Enter report"
                        error={errors?.responseMessage}
                    />
                </div>
            </div>

            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={modalClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoaders}
                    onClick={addReport}
                    className="button"
                >
                    Submit
                </button>
            </div>
        </CustomModal>
    )
}

export default Report